import { render, staticRenderFns } from "./StudentListLayout.vue?vue&type=template&id=d43766c6&scoped=true&lang=pug&"
import script from "./StudentListLayout.vue?vue&type=script&lang=ts&"
export * from "./StudentListLayout.vue?vue&type=script&lang=ts&"
import style0 from "./StudentListLayout.vue?vue&type=style&index=0&id=d43766c6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d43766c6",
  null
  
)

export default component.exports